import './style.scss'
import { useContext, useEffect, useRef, useState } from 'react'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import UserContext from 'src/provider/state-manager/userProvider'
import { AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer, ScreenContainer, UploadContainer } from "src/style"
import UploadIcon from 'src/assets/svg/onboarding-upload-icon'
import CameraIcon from 'src/assets/svg/onboarding-camera-icon'
import PicIcon from 'src/assets/svg/pics-icon'
import helpers from 'src/utils/helpers'
import { useNavigate } from 'react-router-dom'
import Webcam from "react-webcam";
import { RiDeleteBinLine } from 'react-icons/ri'
import { IoArrowBackOutline } from 'react-icons/io5'
import { FiChevronDown } from 'react-icons/fi'


export const UserVerificationD1: React.FC<any> = () => {
    const navigate = useNavigate()
    const {info, setInfoProperty} = useContext(AppInfoContext)
    const {API} = useContext(ApiContext)
    const {user: {onboardingInput}, setUserProperty} = useContext(UserContext)
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({
        photo: onboardingInput?.customerImage || '', 
        picture: onboardingInput?.picture || '',  
        signature: onboardingInput?.customerSignature || '',
        identificationType: onboardingInput?.identificationType || '', 
        identificationID: onboardingInput?.identificationID || '', 
        tin: onboardingInput?.tin || '',
        tinImage: onboardingInput?.tinImage || '',
        identificationImage:onboardingInput?.identificationImage || ''
    })
    const [isPicture, setIsPicture] = useState(onboardingInput?.hasTakenPicture)
    const [hover, setHover] = useState({pics: false, signature: false, tinImage: false, identificationImage:false})
    const webcamRef = useRef<any>(null);
    const signatureRef = useRef<any>(null);
    const tinImageRef = useRef<any>(null);
    const identificationImageRef = useRef<any>(null);
    const [onboardingType, setOnboardingType] = useState(info.onboardingType)

    let isRfsFlow = info.institutionData.onboardingFlow === 'RFS'

    useEffect(() => {
        if (info.onboardingType) setOnboardingType(info.onboardingType)
    }, [info.onboardingType])

    async function handleFile (e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.files instanceof FileList) {
            if(!helpers.isValidFileType(e.target.value)) {
                setInput({...input, [e.target.name]: ''})
                return notifier.show('Only PNG, JPG and JPEG files are allowed', 'Validation Error')
            }

            let uploadedFile = await helpers.compressImage(e.target.files[0])

            if (!uploadedFile) return notifier.show('Unable to compress large file size uploaded')

            helpers.convertFileToBase64(uploadedFile)
            .then(async (result) => {
                setInput({...input, [e.target.name]: result})
            })
            .catch(err => {
                notifier.show(JSON.stringify(err), 'Validation Error')
            })
            // setInput({...input, [e.target.name]: URL.createObjectURL(e.target.files[0])})
        }
    }
    
    async function handlePicture () {
        const pics = webcamRef.current.getScreenshot() as string

        //let base64 = pics.replace('data:image/png;base64,', '').replace('data:image/jpeg;base64,', '').replace('data:image/jpg;base64,', '') 
        // setInput({...input, picture: pics, photo: base64})

        // This below implemetation is basically to ensure file is compressed to fall to the expected maximum size
        let base64 = pics.replace('data:image/png;base64,', '').replace('data:image/jpeg;base64,', '').replace('data:image/jpg;base64,', '') 
        let file = await helpers.ConvertBase64toFile(base64, 'profile-pics')
        file = await helpers.compressImage(file)

        if (!file) return notifier.show('Unable to compress large size face captured')

        helpers.convertFileToBase64(file)
        .then(async (result) => {
            setInput({...input, picture: pics, photo: result})
        })
    }

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        let exemptionProperties = onboardingType !== 'new-user' ? ['identificationType', 'identificationID', 'tin', 'tinImage'] : !isRfsFlow ? ['tin', 'tinImage','identificationImage'] : []
        const {isValidated, message} = helpers.inputValidator(input, exemptionProperties)
        if (!isValidated) return notifier.show(message, 'Validation Response')

        setInfoProperty('onboardingProcessStatus', {...info.onboardingProcessStatus, isUserVerified: true})
        setUserProperty('onboardingInput', {
            ...onboardingInput, 
            customerImage: input.photo,
            customerSignature: input.signature,
            picture: input.picture,
            hasTakenPicture: input.photo,
            [isRfsFlow ? 'identificationImageType' : 'identificationType']: input.identificationType, 
            identificationID: input.identificationID,
            tin: input.tin,
            tinImage: input.tinImage,
            identificationImage: input.identificationImage
        })

        navigate('/onboarding/info-confirmation')

        //disable verify me 
        // if (onboardingType === 'new-user' && !isRfsFlow) {
        //     const response = await API.verifyIdentity({...input, identificationImage: input.photo})
        //     if (response) navigate('/onboarding/info-confirmation')
        // }
        // else navigate('/onboarding/info-confirmation')
        
    }

    return (
        <ScreenContainer padding='2.5' height='auto' sizeUnit=''>
            <CustomContainer className='onboarding-screen-container'>
                <AppText 
                    textSize='3' color='#101828' 
                    bottomMargin='1.5' fontFamily='Gilmer-Bold'
                >
                    Verification
                </AppText>
                <AppSpan>Let's verify your identity</AppSpan>
                <CustomContainer topMargin='2.5'>
                    <Form onSubmit={handleSubmit}>
                        { onboardingType === 'new-user' &&
                            <>
                                <FormGroupWithIcon bottomMargin='2'>
                                    <label>Choose your identification type</label>
                                    <div className="input-with-icon">
                                        <select 
                                            placeholder="Select Type"
                                            name='identificationType'
                                            value={input.identificationType}
                                            style={{color: input.identificationType ? '#000000' : '#667085'}}
                                            onChange={(e) => setInput({...input, identificationType: e.target.value})}
                                            required
                                        >
                                            <option value="">Select Type</option>
                                            { isRfsFlow ?
                                                <>
                                                    <option value="0">International Passport</option>
                                                    <option value="1">National Identity Card</option>
                                                    <option value="2">Driver's License</option>
                                                    <option value="3">Others</option>
                                                    <option value="4">Voter's card</option>
                                                </>
                                                :
                                                <>
                                                    <option value="0">Driver's License</option>
                                                    <option value="2">National ID / NIN Slip</option>
                                                    {/* <option value="5">Virtual NIN</option> */}
                                                    <option value="3">BVN</option>
                                                </>
                                            }
                                        </select>
                                        <FiChevronDown className="input-with-icon-tag" />
                                    </div>
                                </FormGroupWithIcon>
                                <FormGroup>
                                    <label>ID Number</label>
                                    <input 
                                        placeholder='Enter ID Number' 
                                        name='identificationID'
                                        value={input.identificationID}
                                        onChange={(e) => setInput({...input, identificationID: e.target.value})}
                                        autoComplete="off"
                                        required
                                    />
                                </FormGroup>
                                { isRfsFlow &&
                                    <FormGroup>
                                        <label>TIN</label>
                                        <input 
                                            placeholder='Enter TIN' 
                                            name='tin'
                                            value={input.tin}
                                            onChange={(e) => setInput({...input, tin: e.target.value})}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                }
                            </>
                        }
                        { ((onboardingType === 'new-user' && input.identificationType && input.identificationID) || onboardingType !== 'new-user') &&
                            <CustomContainer>
                                { !isPicture &&
                                    <UploadContainer 
                                        borderColor='#EAECF0' radius='0.8' minHeight='12.6'
                                        padding='1.5' hoverColor="#0D968F"
                                        className='doc-upload-container'
                                        onClick={() => setIsPicture(true)}
                                        onMouseEnter={() => setHover({...hover, pics: true})}
                                        onMouseLeave={() => setHover({...hover, pics: false})}
                                    >
                                        <CameraIcon isHover={hover.pics} className='icon-component' />
                                        {/* <input type="file" name='picture' onChange={handleFile} className="file-input" id="picture" /> */}
                                        <AppLabel color='#0A756F' fontWeight='600' topMargin='1' htmlFor='picture'>Click to take a Picture</AppLabel>
                                    </UploadContainer>
                                }
                                { isPicture &&
                                    <CustomContainer>
                                        <CustomContainer
                                            height='20' radius='0.4' overflow='hidden'
                                            //style={{border: `4px dashed ${!input ? '#141B34' : '#6DE7B4' }`}}
                                        >
                                            { !input.picture ?
                                                <Webcam
                                                    audio={false}
                                                    screenshotFormat="image/jpeg"
                                                    className='faceScan-camera'
                                                    ref={webcamRef}
                                                    videoConstraints={{facingMode: 'user'}}
                                                    onUserMediaError={() => notifier.show('Camera not supported')}
                                                /> :
                                                <img src={input.picture} className='faceScan-camera' />
                                            }
                                        </CustomContainer>
                                        <GridContainer>
                                            <Button
                                                width={!input.picture ? "11" : "13"} height="2.5" borderColor='#0D968F'
                                                hoverBgColor="#ffffff" topMargin="2" type='button'
                                                titleSize="1.2" radius="0.4" hoverColor='#0D968F'
                                                onClick={!input.picture ? handlePicture : () => setInput({...input, picture: '', photo: ''})}
                                            >
                                                {!input.picture ? 'Capture my face' : 'Re-capture my face'}
                                            </Button>
                                        </GridContainer>
                                    </CustomContainer>
                                }
                                { !input.signature &&
                                    <UploadContainer 
                                        borderColor='#EAECF0' radius='0.8' minHeight='12.6'
                                        padding='1.5' topMargin='2.5' hoverColor="#0D968F"
                                        className='doc-upload-container'
                                        onClick={() => signatureRef.current.click()}
                                        onMouseEnter={() => setHover({...hover, signature: true})}
                                        onMouseLeave={() => setHover({...hover, signature: false})}
                                    >
                                        <UploadIcon isHover={hover.signature} className='icon-component' />
                                        <input type="file" name='signature' onChange={handleFile} ref={signatureRef} className="file-input" id="signature" />
                                        <AppLabel 
                                            color='#0A756F' fontWeight='600' topMargin='1' //htmlFor='signature'
                                        >
                                            Click to upload a Signature
                                        </AppLabel>
                                        <AppSpan color='#667085' textSize='1.2' topMargin='0.3'>PNG or JPG</AppSpan>
                                    </UploadContainer>
                                }
                                { (!input.tinImage && isRfsFlow) &&
                                    <UploadContainer 
                                        borderColor='#EAECF0' radius='0.8' minHeight='12.6'
                                        padding='1.5' topMargin='2.5' hoverColor="#0D968F"
                                        className='doc-upload-container'
                                        onClick={() => tinImageRef.current.click()}
                                        onMouseEnter={() => setHover({...hover, tinImage: true})}
                                        onMouseLeave={() => setHover({...hover, tinImage: false})}
                                    >
                                        <UploadIcon isHover={hover.tinImage} className='icon-component' />
                                        <input type="file" name='tinImage' onChange={handleFile} ref={tinImageRef} className="file-input" id="tinImage" />
                                        <AppLabel 
                                            color='#0A756F' fontWeight='600' topMargin='1' //htmlFor='signature'
                                        >
                                            Click to upload a Tin Document
                                        </AppLabel>
                                        <AppSpan color='#667085' textSize='1.2' topMargin='0.3'>PNG or JPG</AppSpan>
                                    </UploadContainer>
                                }

                                { (!input.identificationImage && isRfsFlow) &&
                                    <UploadContainer 
                                        borderColor='#EAECF0' radius='0.8' minHeight='12.6'
                                        padding='1.5' topMargin='2.5' hoverColor="#0D968F"
                                        className='doc-upload-container'
                                        onClick={() => identificationImageRef.current.click()}
                                        onMouseEnter={() => setHover({...hover, identificationImage: true})}
                                        onMouseLeave={() => setHover({...hover, identificationImage: false})}
                                    >
                                        <UploadIcon isHover={hover.identificationImage} className='icon-component' />
                                        <input type="file" name='identificationImage' onChange={handleFile} ref={identificationImageRef} className="file-input" id="identificationImage" />
                                        <AppLabel 
                                            color='#0A756F' fontWeight='600' topMargin='1' //htmlFor='signature'
                                        >
                                            Click to upload an identification image
                                        </AppLabel>
                                        <AppSpan color='#667085' textSize='1.2' topMargin='0.3'>PNG or JPG</AppSpan>
                                    </UploadContainer>
                                }       

                                { (input.photo || input.signature || input.tinImage) &&
                                    <CustomContainer topMargin='2.5'>
                                        <AppLabel textSize='1.6'>Uploaded Document(s)</AppLabel>
                                        { input.photo &&
                                            <GridContainer 
                                                borderColor='#0D968F' radius='0.8' minHeight='9.6'
                                                padding='1' topMargin='1.5'
                                            >
                                                <FlexRow alignItems='flex-start'>
                                                    <AbsoluteContainer top='0' right='0'>
                                                        <AppSpan 
                                                            textSize='1.8' color='#667085' hoverColor='#F80000' cursor='pointer'
                                                            onClick={() => setInput({...input, photo: '', picture: ''})}
                                                        >
                                                            <RiDeleteBinLine />
                                                        </AppSpan>
                                                    </AbsoluteContainer>
                                                    <PicIcon 
                                                        className='icon-component' 
                                                        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                                    />
                                                    <CustomContainer leftMargin='1.5'>
                                                        <AppLabel color='#344054' fontWeight='600'>Photo ID</AppLabel>
                                                        <AppText color='#667085' topMargin='-0.7' >{helpers.getFileSize(input.photo)} KB</AppText>
                                                        <FlexRow gap='1'>
                                                            <CustomContainer width='85' height='0.8' sizeUnit='%' bgColor='#EAECF0' radius='0.4' overflow='hidden' >
                                                                <CustomContainer bgColor='#0D968F' height='0.8' radius='0.4' width='100' sizeUnit='%'/>
                                                            </CustomContainer>
                                                            <AppSpan color='#344054' fontWeight='600'>100%</AppSpan>
                                                        </FlexRow>
                                                    </CustomContainer>
                                                </FlexRow>
                                            </GridContainer>
                                        }
                                        { input.signature &&
                                            <GridContainer 
                                                borderColor='#0D968F' radius='0.8' minHeight='9.6'
                                                padding='1' topMargin='2'
                                            >
                                                <FlexRow alignItems='flex-start'>
                                                    <AbsoluteContainer top='0' right='0'>
                                                        <AppSpan 
                                                            textSize='1.8' color='#667085' hoverColor='#F80000' cursor='pointer'
                                                            onClick={() => setInput({...input, signature: ''})}
                                                        >
                                                            <RiDeleteBinLine />
                                                        </AppSpan>
                                                    </AbsoluteContainer>
                                                    <PicIcon 
                                                        className='icon-component' 
                                                        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                                    />
                                                    <CustomContainer leftMargin='1.5'>
                                                        <AppLabel color='#344054' fontWeight='600'>Signature</AppLabel>
                                                        <AppText color='#667085' topMargin='-0.7' >{helpers.getFileSize(input.signature)} KB</AppText>
                                                        <FlexRow gap='1'>
                                                            <CustomContainer width='85' height='0.8' sizeUnit='%' bgColor='#EAECF0' radius='0.4' overflow='hidden' >
                                                                <CustomContainer bgColor='#0D968F' height='0.8' radius='0.4' width='100' sizeUnit='%'/>
                                                            </CustomContainer>
                                                            <AppSpan color='#344054' fontWeight='600'>100%</AppSpan>
                                                        </FlexRow>
                                                    </CustomContainer>
                                                </FlexRow>
                                            </GridContainer>
                                        }
                                        { input.tinImage &&
                                            <GridContainer 
                                                borderColor='#0D968F' radius='0.8' minHeight='9.6'
                                                padding='1' topMargin='2'
                                            >
                                                <FlexRow alignItems='flex-start'>
                                                    <AbsoluteContainer top='0' right='0'>
                                                        <AppSpan 
                                                            textSize='1.8' color='#667085' hoverColor='#F80000' cursor='pointer'
                                                            onClick={() => setInput({...input, tinImage: ''})}
                                                        >
                                                            <RiDeleteBinLine />
                                                        </AppSpan>
                                                    </AbsoluteContainer>
                                                    <PicIcon 
                                                        className='icon-component' 
                                                        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                                    />
                                                    <CustomContainer leftMargin='1.5'>
                                                        <AppLabel color='#344054' fontWeight='600'>Tin Document</AppLabel>
                                                        <AppText color='#667085' topMargin='-0.7' >{helpers.getFileSize(input.tinImage)} KB</AppText>
                                                        <FlexRow gap='1'>
                                                            <CustomContainer width='85' height='0.8' sizeUnit='%' bgColor='#EAECF0' radius='0.4' overflow='hidden' >
                                                                <CustomContainer bgColor='#0D968F' height='0.8' radius='0.4' width='100' sizeUnit='%'/>
                                                            </CustomContainer>
                                                            <AppSpan color='#344054' fontWeight='600'>100%</AppSpan>
                                                        </FlexRow>
                                                    </CustomContainer>
                                                </FlexRow>
                                            </GridContainer>
                                        }
                                        
                                        { input.identificationImage &&
                                            <GridContainer 
                                                borderColor='#0D968F' radius='0.8' minHeight='9.6'
                                                padding='1' topMargin='2'
                                            >
                                                <FlexRow alignItems='flex-start'>
                                                    <AbsoluteContainer top='0' right='0'>
                                                        <AppSpan 
                                                            textSize='1.8' color='#667085' hoverColor='#F80000' cursor='pointer'
                                                            onClick={() => setInput({...input, identificationImage: ''})}
                                                        >
                                                            <RiDeleteBinLine />
                                                        </AppSpan>
                                                    </AbsoluteContainer>
                                                    <PicIcon 
                                                        className='icon-component' 
                                                        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                                    />
                                                    <CustomContainer leftMargin='1.5'>
                                                        <AppLabel color='#344054' fontWeight='600'>Identification Image</AppLabel>
                                                        <AppText color='#667085' topMargin='-0.7' >{helpers.getFileSize(input.identificationImage)} KB</AppText>
                                                        <FlexRow gap='1'>
                                                            <CustomContainer width='85' height='0.8' sizeUnit='%' bgColor='#EAECF0' radius='0.4' overflow='hidden' >
                                                                <CustomContainer bgColor='#0D968F' height='0.8' radius='0.4' width='100' sizeUnit='%'/>
                                                            </CustomContainer>
                                                            <AppSpan color='#344054' fontWeight='600'>100%</AppSpan>
                                                        </FlexRow>
                                                    </CustomContainer>
                                                </FlexRow>
                                            </GridContainer>
                                        }
                                    </CustomContainer>
                                }

                                <FlexRow justifyContent='flex-end' topMargin='2.5' gap='1.5'>
                                    <Button 
                                        width='9.3' height='4' bgColor="#ffffff"
                                        borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                                        hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                        childHoverColor='#0D968F' type="button"
                                        onClick={() => navigate(-1)}
                                    >
                                        <AppSpan color='#344054' rightMargin='1' textSize='1.6'>
                                            <IoArrowBackOutline/>
                                        </AppSpan>
                                        Back
                                    </Button>
                                    <Button 
                                        width='8.8' height='4' 
                                        borderColor='#0D968F' hoverBgColor='#fff' 
                                        hoverColor='#0D968F' titleSize='1.4'
                                    >
                                        Proceed
                                    </Button>
                                </FlexRow>
                            </CustomContainer>
                        }
                    </Form>
                </CustomContainer>
            </CustomContainer>
        </ScreenContainer>
    )
}
